import _regeneratorRuntime from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import qs from 'qs';
import cx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import HeaderLogo from './Logo';
import { MobileHeader } from './Mobile';
import { DesktopHeader } from './Desktop';
import { ProPromoBanner, UpdatePaymentBanner } from './Banner';
import { ClientNames } from '../../models';
import { Links } from '../../components/links';
import { InitIntl, ReactIntl } from '../../helpers/intel';
import { useStyles } from './style';

var gtmClicked = function gtmClicked(action, clientName) {
  var page;

  if (clientName == ClientNames.designs_ai) {
    page = window.location.pathname.split('?')[0].split('/').reverse()[0].toLowerCase().replace(/\s/g, '_');
  }

  var id = clientName.trim().toLowerCase().replace(/\s/g, '_');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'btnClick',
    btnLabel: "".concat(action, "-").concat(page || 'Index', "-").concat(id)
  });
};

export var Header = function Header(_ref) {
  var Link = _ref.Link,
      user = _ref.user,
      isLogin = _ref.isLogin,
      isLoading = _ref.isLoading,
      currentLanguage = _ref.currentLanguage,
      _ref$changeLang = _ref.changeLang,
      changeLang = _ref$changeLang === void 0 ? function () {} : _ref$changeLang,
      _ref$currentRoute = _ref.currentRoute,
      currentRoute = _ref$currentRoute === void 0 ? '' : _ref$currentRoute,
      clientName = _ref.clientName,
      clientId = _ref.clientId,
      redirectPath = _ref.redirectPath,
      router = _ref.router,
      _ref$additionalMenu = _ref.additionalMenu,
      additionalMenu = _ref$additionalMenu === void 0 ? [] : _ref$additionalMenu,
      styles = _ref.styles,
      _ref$customHeaderStyl = _ref.customHeaderStyle,
      customHeaderStyle = _ref$customHeaderStyl === void 0 ? {} : _ref$customHeaderStyl,
      _ref$customLinkStyle = _ref.customLinkStyle,
      customLinkStyle = _ref$customLinkStyle === void 0 ? {} : _ref$customLinkStyle,
      isLocal = _ref.isLocal,
      proPlanId = _ref.proPlanId,
      _ref$accountCreatedDa = _ref.accountCreatedDate,
      accountCreatedDate = _ref$accountCreatedDa === void 0 ? null : _ref$accountCreatedDa,
      _ref$onClickBanner = _ref.onClickBanner,
      onClickBanner = _ref$onClickBanner === void 0 ? function () {} : _ref$onClickBanner,
      onAction = _ref.onAction;

  var _a, _b, _c, _d, _e;

  if (!onAction) {
    onAction = function onAction(_ref2) {
      var action = _ref2.action;
      gtmClicked(action, clientName);
      var pathname = "/user/".concat(action === 'signup' ? 'sign-up' : action === 'login' ? 'sign-in' : 'sign-out');
      var query = {};
      if (clientId) query.c = clientId;
      if (redirectPath) query.r = redirectPath;

      if (clientName === ClientNames.designs_ai && router) {
        router.push({
          pathname: pathname,
          query: query
        });
      } else {
        window.location.href = "".concat(isLocal ? 'https://dev.designs.ai' : '').concat(pathname, "?").concat(qs.stringify(query));
      }
    };
  }

  var classes = useStyles(styles);

  var _useState = useState(InitIntl()),
      _useState2 = _slicedToArray(_useState, 2),
      intl = _useState2[0],
      setIntl = _useState2[1];

  var fetchIntel = useCallback(function (lng) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = setIntl;
              _context.next = 3;
              return ReactIntl(lng || 'en', 'header');

            case 3:
              _context.t1 = _context.sent;
              return _context.abrupt("return", (0, _context.t0)(_context.t1));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  }, []);
  var queryPath = typeof window !== 'undefined' ? window.location.pathname : '';
  var profile = (user === null || user === void 0 ? void 0 : user.user_profile) ? user === null || user === void 0 ? void 0 : user.user_profile : 'https://assets.designs.ai/images/svg/icon-avatar.svg';
  var isVisitor = !isLogin && currentLanguage !== 'jp';
  var isFreeUser = isLogin && currentLanguage !== 'jp' && ((_a = user === null || user === void 0 ? void 0 : user.subscription) === null || _a === void 0 ? void 0 : _a.sub_category) === 'free' && queryPath !== '/free-trial' && ((_b = user === null || user === void 0 ? void 0 : user.trial) === null || _b === void 0 ? void 0 : _b.on_trial) === false;
  var isBasicUser = isLogin && currentLanguage !== 'jp' && ((_c = user === null || user === void 0 ? void 0 : user.subscription) === null || _c === void 0 ? void 0 : _c.sub_category) === 'basic' && !queryPath.includes('/user/checkout') && ((_d = user === null || user === void 0 ? void 0 : user.trial) === null || _d === void 0 ? void 0 : _d.on_trial) === false; // Display payment banner if user's subcsription has issue

  var hasPaymentIssue = (_e = user === null || user === void 0 ? void 0 : user.sub_on_hold) === null || _e === void 0 ? void 0 : _e.status;
  useEffect(function () {
    fetchIntel(currentLanguage);
  }, [currentLanguage]);
  return React.createElement(React.Fragment, null, React.createElement("header", {
    style: customHeaderStyle,
    className: cx(classes.header, classes.sticky)
  }, React.createElement(HeaderLogo, {
    classes: classes,
    isLogin: isLogin,
    Link: Link
  }), React.createElement(DesktopHeader, {
    user: user,
    Link: Link,
    intl: intl,
    profile: profile,
    isLogin: isLogin,
    onAction: onAction,
    isLoading: isLoading,
    changeLang: changeLang,
    proPlanId: proPlanId,
    queryPath: queryPath,
    clientName: clientName,
    additionalMenu: additionalMenu,
    currentLanguageLabel: currentLanguage,
    isCheckoutPage: currentRoute.includes('/user/checkout')
  }), React.createElement(MobileHeader, {
    Link: Link,
    intl: intl,
    user: user,
    isLogin: isLogin,
    profile: profile,
    onAction: onAction,
    queryPath: queryPath,
    changeLang: changeLang,
    proPlanId: proPlanId,
    additionalMenu: additionalMenu,
    currentLanguageLabel: currentLanguage,
    isCheckoutPage: currentRoute.includes('/user/checkout')
  })), React.createElement(ProPromoBanner, {
    user: user,
    intl: intl,
    isLogin: isLogin,
    currentRoute: currentRoute,
    onClickBanner: onClickBanner,
    currentLanguage: currentLanguage,
    accountCreatedDate: accountCreatedDate
  }), hasPaymentIssue && React.createElement(UpdatePaymentBanner, {
    intl: intl
  }), isVisitor || isFreeUser ? React.createElement(Links, {
    Link: Link,
    to: '/free-trial',
    className: cx(classes.sticky, classes.sub_header),
    style: customLinkStyle
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'try_for_free',
    defaultMessage: 'Try for free'
  })) : isBasicUser ? React.createElement(Links, {
    Link: Link,
    to: '/user/checkout?q=' + proPlanId,
    className: cx(classes.sticky, classes.sub_header),
    style: customLinkStyle
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'try_pro',
    defaultMessage: 'Try Pro'
  }), React.createElement("img", {
    src: 'https://assets.designs.ai/images/procrown.svg',
    width: '18px',
    height: '18px',
    alt: 'Designs.ai Pro crown'
  })) : '');
};